import React, { ReactNode, useContext, useEffect, useState } from "react";
import { api, IProductsByParent, Product } from "../../../logic/api";
import TreeViewNode from "../TreeViewNode";
import propTypes from "prop-types";
import { PagedDataView } from "../../lists/PagedDataView/PagedDataView";
import { ITreeViewLoaderProps, TreeViewCommand, TreeViewContext } from "../TreeView";

interface IFlags {
    filter: string;
    includeInactive: boolean;
}

export interface IProductsTreeViewLoaderProps extends ITreeViewLoaderProps {
    renderItem?: (item: Product, index: number) => ReactNode;
}

const ProductsTreeViewLoader: React.FunctionComponent<IProductsTreeViewLoaderProps> = (props) => {
    const flags: IFlags = (props.flags || {}) as IFlags;


    const [params, setParams] = useState<IProductsByParent>({
        parentId: props.parentId,
        filter: flags.filter
    });

    useEffect(() => {
        setParams({ ...params, ...flags });
    }, [flags.filter, flags.includeInactive]);


    const tvc = useContext(TreeViewContext);

    useEffect(() => {
        if (tvc.state) {
            if (tvc.state.command) {
                if (tvc.state.command.command == TreeViewCommand.reloadAll) {
                    if (props.parentId == tvc.state.treeRootId) {
                        setParams({ ...params });
                        if (tvc.setState) {
                            tvc.setState({
                                ...tvc.state,
                                command: undefined
                            });
                        }
                    }
                } else if (tvc.state.command.command == TreeViewCommand.reload) {
                    if (props.parentId == tvc.state.command.targetId) {
                        setParams({ ...params });
                        if (tvc.setState) {
                            tvc.setState({
                                ...tvc.state,
                                command: undefined
                            });
                        }

                    }
                }
            }
        }
    }, [tvc.state != null ? tvc.state.command : null]);

    const renderItem = (item: Product) => {
        const children = props.renderItem
            ? props.renderItem(item, 0)
            : "";
        return <TreeViewNode record={item}>{children}</TreeViewNode>;
    }

    return <PagedDataView<IProductsByParent, Product>
        apiHook={api.hooks.products.getByParent}
        parameters={params}
        renderItem={renderItem}
    ></PagedDataView>
}

ProductsTreeViewLoader.propTypes = {
    parentId: propTypes.number.isRequired,
    flags: propTypes.any,
}

export default ProductsTreeViewLoader;
